import React from 'react';
import { Route } from 'react-router-dom';
import { DocumentsPage } from './DocumentsPage';

export const routes = [<Route key="1" path="/properties/:propertyId/document" component={DocumentsPage} />];

export const navigation = [{ name: 'Document', link: '/Document' }];
